export default require("../../config.js").default;